// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__30jXx","footer":"ChangeClinic_footer__3LIMG"};